/**
 * Offizielles Logo der Parfümerie Brückner.
 * Quelle: Edge-Caddy `/brand/*` (portal-infra `portal/caddy/site/login/brand/`) — eine Asset-Quelle,
 * keine Kopie im portal-Repo (#803).
 * Standard = weißes Logo auf dunklem Logo-Kopf (Login-Karte).
 * `klein` = Anwendungskopf ohne Kasten (#812): hell Logo braun (#4B3D31), dunkel Logo weiß; Wechsel per CSS am Theme.
 */
export const BRAND_LOGO_SRC = '/brand/logo-weiss.png';
export const BRAND_LOGO_BRAUN_SRC = '/brand/logo-braun.png';

export function BrandLogo({ klein = false, className }: { klein?: boolean; className?: string }) {
  if (klein) {
    return (
      <span
        className={['pb-logo', 'pb-logo--klein', className].filter(Boolean).join(' ')}
        role="img"
        aria-label="Parfümerie Brückner"
      >
        <img className="pb-logo__hell" src={BRAND_LOGO_BRAUN_SRC} alt="" width={480} height={203} />
        <img className="pb-logo__dunkel" src={BRAND_LOGO_SRC} alt="" width={480} height={203} />
      </span>
    );
  }
  return (
    <span className={['pb-logo', className].filter(Boolean).join(' ')}>
      <img src={BRAND_LOGO_SRC} alt="Parfümerie Brückner" width={480} height={203} />
    </span>
  );
}
